import React from "react";
import "../../../style/common/_spinner.scss";

const  PageLoading = () => {
  return (
    <div className="loading-list">
      <div className="loader loader-1" style={{top: "40%"}}></div>
    </div>
  )
}
export default PageLoading;